module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mbnskms3-54f834dccc6da12d94fbfe8ec1575c7e.jpg";